import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Query } from '@apollo/client/react/components';
import { graphql } from '@apollo/client/react/hoc';
import PropTypes from 'prop-types';
import showTimesheetsFooterAlert from 'schemas/queries/featureFlags/showTimesheetsFooterAlert.graphql';

import { getShowGeofenceOverlay } from 'selectors/session';

import getIsEmbedded from 'util/embedded';

import GeofenceOverlay from './GeofenceOverlay';
import TimesheetsFooterAlert from './TimesheetsFooterAlert';

@graphql(showTimesheetsFooterAlert, {
  options: () => ({
    fetchPolicy: 'cache-first',
  }),
})
@connect((state, props) => ({
  showGeofenceOverlay: getShowGeofenceOverlay(state, props),
}))
export default class Timesheets extends PureComponent {
  static propTypes = {
    showGeofenceOverlay: PropTypes.bool,
  };

  render() {
    const isEmbedded = getIsEmbedded();

    return (
      <div>
        {this.props.showGeofenceOverlay && <GeofenceOverlay />}

        {!isEmbedded && (
          <Query query={showTimesheetsFooterAlert}>
            {({ data }) => {
              if (!data) return null;
              if (!data.showTimesheetsFooterAlert) return null;
              return <TimesheetsFooterAlert />;
            }}
          </Query>
        )}
      </div>
    );
  }
}
